import { render, staticRenderFns } from "./infoBox_list.vue?vue&type=template&id=042c9fac&scoped=true&"
import script from "./infoBox_list.vue?vue&type=script&lang=js&"
export * from "./infoBox_list.vue?vue&type=script&lang=js&"
import style0 from "./infoBox_list.vue?vue&type=style&index=0&id=042c9fac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042c9fac",
  null
  
)

export default component.exports